<loader-spinner size="normal"/>